/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

/**
 * WARNING: Constants for debug only
 *
 * RULES:
 * 1. Should be restricted to boolean values with the following logic:
 *    * true: the debug feature is active
 *    * false: the debug feature is inactive
 *
 * 2. All values should have 'DEBUG_ON && ' expression prefix -> To avoid debug functionalities in production builds
 *
 * 3. Should always be committed with all keys set to false except for loggers -> To avoid unexpected behaviors while getting code from other programers
 *
 * 4. Property names should be explicit about what they do
 */

export const DEBUG_ON = process.env.NODE_ENV === 'development';

const IFDebug = {
  // LOGGERS
  LOG_REDUX_STATE: DEBUG_ON && false,
  LOG_REDUX_STATE_BLACK_LIST_REGEX:
    /^(app\/layoutProgressBar\/SET_PERCENTAGE|player\/SET_STREAM_PROGRESS|epg\/buffer\/.*|epg\/programs\/SUCCESS|analytics\/engine\/.*|consumption\/.*)$/i,
  REACT_NATIVE_LOG_BOX_ENABLED: DEBUG_ON && false,

  // CACHE
  SKIP_CHANNELS_CACHE: DEBUG_ON && false,

  // PLAYER
  DESTROY_PLAYER: DEBUG_ON && true,
  USE_HARDCODED_STREAMS: DEBUG_ON && false,

  // MENU
  SKIP_MENU_CATEGORIES: DEBUG_ON && false,
};

export default IFDebug;
